import React from 'react';
import { Navigate, Outlet, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from './Button';
import { Stepper } from './Stepper';
import { StatusMarker } from './StatusMarker';
import { usePlatform } from '../contexts/PlatformContext';
export function AppShell() {
  const {
    authenticated,
    user,
    goal,
    signOut,
    switchProfile
  } = usePlatform();
  const navigate = useNavigate();
  if (!user) return <Navigate to={authenticated ? '/choose-profile' : '/'} replace data-id="element-22" data-mp="1ga5c3lhumbtt" />;
  const initials = user.name.split(' ').map(n => n[0]).join('').slice(0, 2).toUpperCase();
  return <div className="min-h-screen w-full bg-[#0f1017]" data-id="element-23" data-mp="16jaghqippzvp">
      <header className="sticky top-0 z-20 border-b border-white/10 bg-[#0f1017]/85 backdrop-blur" data-id="element-24" data-mp="1bhvgppxysjk5">
        <div className="mx-auto flex max-w-6xl items-center justify-between gap-6 px-6 py-4" data-id="element-25" data-mp="1z7zgtnby216e">
          <span className="text-xl font-semibold tracking-tight" data-id="element-26" data-mp="23z7syr4ns0n9">nawat</span>
          <Stepper data-id="element-27" data-mp="1rcv91lczdx2w" />
          <div className="flex items-center gap-2" data-id="element-28" data-mp="1rc28j24m83t7">
            {goal && <span className="hidden sm:inline-flex" data-id="element-29" data-mp="1me0puib3q6i9">
                <StatusMarker goal={goal} size="sm" data-id="element-30" data-mp="1mfbuekcdfiaf" />
              </span>}
            <button onClick={() => {
            switchProfile();
            navigate('/choose-profile');
          }} className="flex size-8 items-center justify-center rounded-full border border-[#9b8cf0]/50 font-mono text-xs text-[#c4baff] transition-colors hover:bg-[#9b8cf0]/15 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#9b8cf0]" title={`${user.name} · Switch profile`} aria-label={`Signed in as ${user.name}. Switch profile`} data-id="element-31" data-mp="213gd3obfbtt7">
              {initials}
            </button>
            <Button variant="ghost" size="icon-sm" aria-label="Sign out" onClick={() => {
            signOut();
            navigate('/');
          }} data-id="element-32" data-mp="pojbley1zc4y">
              <LogOut className="size-4" data-id="element-33" data-mp="1aen8fsmogv7s" />
            </Button>
          </div>
        </div>
      </header>
      <main className="mx-auto max-w-6xl px-6 py-10 md:py-14" data-id="element-34" data-mp="1eg8iz7bqoxet">
        <Outlet data-id="element-35" data-mp="1jch2ewwyzcrs" />
      </main>
    </div>;
}